export type ActiveID = number | null;

export enum ActiveAnnotationActionEnum {
  setActiveAnnotation = 'SET_ACTIVE_ANNOTATION'
}

export type SetActiveAnnotationAction = {
  type: ActiveAnnotationActionEnum.setActiveAnnotation;
  payload: {
    id: ActiveID;
  };
};
